<!-- SharingHistoryDialog.vue -->
<script lang="ts" setup>
import { computed, reactive, watch } from 'vue';
import GeneralDialog from '../../components/GeneralDialog.vue';
import SharingHistoryTable from './SharingHistoryTable.vue';
import { ISurescriptsDocumentShareEvent } from '../../lib/Api/SurescriptsRecordLocator';
import Icon from '../../components/Icon.vue';
import { IconTypes, HoverCursorTypes, DisplayStyle } from '../../Enums/UiEnums';
import { ChoiceApi } from '../../LibMain';
import { DatabaseIdTypes } from '../../Enums/ChoiceEnums';
import { popAlert } from '../../lib/Notification';
import { assertInternally } from '../../lib/Environment';
import LoadingSection from '../../components/LoadingSection.vue';


    const props = withDefaults(defineProps<{
        show?: boolean,
        patientId: number
    }>(), {
        show: false,
    });

    const emit = defineEmits<{
        (e: "update:show", currentValue: boolean): void
    }>();

    const compData = reactive<{
        showDocument?: boolean,
        shareEventInfoToShow?: ISurescriptsDocumentShareEvent,
        loadingDocument?: boolean
    }>({});

    watch(()=> props.show, (newVal, _oldVal)=>{
        if (true !== newVal)
            showList();
    });

    const dialogTitle = computed(()=>{
        if (compData.showDocument)
        {
            switch(compData.shareEventInfoToShow?.sharedItemIdType)            
            {
                case DatabaseIdTypes.ccd_id:
                case DatabaseIdTypes.patient_ccda_record_id:
                    return "Continuity of Care Document (CCD)";

                default:
                    assertInternally(`Unhandled idType: ${compData.shareEventInfoToShow?.sharedItemIdType}`);
                    return "Unknown Document Type";
            }
        }
        return "Sharing History";
    });    

    function viewDocument(shareEventInfo: ISurescriptsDocumentShareEvent)
    {
        compData.shareEventInfoToShow = shareEventInfo;
        compData.loadingDocument = true;
        compData.showDocument = true;
    }

    const documentSrc = computed<string|undefined>(() =>{
        switch(compData.shareEventInfoToShow?.sharedItemIdType)
        {
            case DatabaseIdTypes.ccd_id:
            case DatabaseIdTypes.patient_ccda_record_id:
            return ChoiceApi.CCD.choiceCcdViewerUrl(compData.shareEventInfoToShow?.sharedItemId, compData.shareEventInfoToShow?.sharedItemIdType);

            default:
            return;
        }
    });

    function errorLoadingDocument(_err: any)
    {
        compData.loadingDocument = false; 
        popAlert('Error trying to load document');
    }    

    function showList()
    {
        compData.showDocument = false;
        compData.loadingDocument = false;
    }
</script>

<template>
    <GeneralDialog 
            :show="props.show" 
            :closeModalOnClickOutside="false"
            @update:show="val => emit('update:show', val)">
        <template #title>
            <Icon v-if="compData.showDocument" 
                    :icon="IconTypes.ArrowLeft" :hoverCursor="HoverCursorTypes.Pointer" @click="() => showList()" />
            {{ dialogTitle }}
        </template>
        <!-- Set minimum dialog width -->
        <div style="height: 0px; width: 75vw;"></div>        
        <SharingHistoryTable v-if="!compData.showDocument" :patientId="props.patientId" @viewDocument="viewDocument"/>

        <template v-if="compData.showDocument">
            <LoadingSection :isLoading="compData.loadingDocument" loadingMsg="Loading document..." />

            <iframe 
                v-if="documentSrc" 
                title="Document" 
                :src="documentSrc"
                @load="compData.loadingDocument = false"
                @error="errorLoadingDocument"
                style="height: 80vh; width: 90vw">
            </iframe>
        </template>
    </GeneralDialog>
</template>